{
  "version": 1,
  "updatedAt": "2026-07-04T00:00:00Z",
  "providers": {
    "claude": {
      "name": "Claude Code with Anthropic",
      "defaultModel": "opus[1m]",
      "models": [
        { "modelId": "haiku", "name": "Claude Haiku", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "low" } },
        { "modelId": "sonnet", "name": "Claude Sonnet", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "medium" } },
        { "modelId": "opus", "name": "Claude Opus", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "xhigh" } },
        { "modelId": "opus[1m]", "name": "Claude Opus [1M]", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "xhigh" } },
        { "modelId": "claude-opus-4-6[1m]", "name": "Claude Opus 4.6 [1M]", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "high" } },
        { "modelId": "claude-opus-4-7[1m]", "name": "Claude Opus 4.7 [1M]", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "high" } },
        { "modelId": "claude-opus-4-8[1m]", "name": "Claude Opus 4.8 [1M]", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "high" } }
      ]
    },
    "codex": {
      "name": "OpenAI Codex CLI",
      "defaultModel": "gpt-5.4",
      "models": [
        { "modelId": "gpt-5.4", "name": "GPT-5.4", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh"], "default": "high" } },
        { "modelId": "gpt-5.5", "name": "GPT-5.5", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh"], "default": "high" } },
        { "modelId": "gpt-5.4-mini", "name": "GPT-5.4 Mini", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh"], "default": "high" } }
      ]
    },
    "opencode-go": {
      "name": "OpenCode Go",
      "defaultModel": "opencode-go/glm-5.1",
      "models": [
        { "modelId": "opencode-go/deepseek-v4-flash", "name": "DeepSeek V4 Flash", "effort": { "supported": false } },
        { "modelId": "opencode-go/deepseek-v4-pro", "name": "DeepSeek V4 Pro", "effort": { "supported": false } },
        { "modelId": "opencode-go/glm-5", "name": "GLM-5", "effort": { "supported": false } },
        { "modelId": "opencode-go/glm-5.1", "name": "GLM-5.1", "effort": { "supported": false } },
        { "modelId": "opencode-go/glm-5.2", "name": "GLM-5.2", "effort": { "supported": false } },
        { "modelId": "opencode-go/kimi-k2.6", "name": "Kimi K2.6 (3x limits)", "effort": { "supported": false } },
        { "modelId": "opencode-go/kimi-k2.7-code", "name": "Kimi K2.7 Code", "effort": { "supported": false } }
      ]
    },
    "cursor": {
      "name": "Cursor Agent",
      "defaultModel": "auto",
      "models": [
        { "modelId": "auto", "name": "Auto", "effort": { "supported": false } },
        { "modelId": "composer-2.5-fast", "name": "Composer 2.5 Fast", "description": "Cursor Composer 2.5 (fast variant, default upstream)", "effort": { "supported": false } },
        { "modelId": "composer-2.5", "name": "Composer 2.5", "description": "Cursor Composer 2.5 (standard variant)", "effort": { "supported": false } },
        { "modelId": "gemini-3.1-pro", "name": "Gemini 3.1 Pro", "effort": { "supported": false } },
        { "modelId": "gemini-3-flash", "name": "Gemini 3 Flash", "effort": { "supported": false } },
        { "modelId": "gemini-3.5-flash", "name": "Gemini 3.5 Flash", "effort": { "supported": false } },
        { "modelId": "kimi-k2.7-code", "name": "Kimi K2.7 Code", "effort": { "supported": false } },
        { "modelId": "glm-5.2", "name": "GLM 5.2", "spawnModelTemplate": "glm-5.2-{effort}", "effort": { "supported": true, "levels": ["high", "max"], "default": "max" } },
        { "modelId": "claude-opus-4-8-thinking", "name": "Claude Opus 4.8 Thinking", "spawnModelTemplate": "claude-opus-4-8-thinking-{effort}", "effort": { "supported": true, "levels": ["low", "medium", "high", "xhigh", "max"], "default": "xhigh" } }
      ]
    }
  }
}
